var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _rect2, _path33, _path34, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroceryStoreThumbnailGray = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "#D5D8DD",
    stroke: "#67717E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.3696 34.7323C79.6354 26.1463 72.8409 22.8041 69.4105 22.2063C68.3848 21.9558 66.9234 21.2613 66.3209 20.9454C66.4798 20.2118 66.8645 18.896 67.1317 19.5019C67.4659 20.2593 68.3992 20.119 69.5086 20.1725C70.6179 20.226 74.8459 17.0942 79.9491 22.7145C84.0317 27.2107 82.3732 32.6533 81.0336 34.8125C80.2227 36.256 79.5864 35.3604 79.3696 34.7323Z",
    fill: "#F1F2F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3661 20.0768C74.888 20.0613 82.9313 20.8198 82.1005 31.8989C82.0672 28.7468 79.7757 20.9271 71.3661 20.0768Z",
    fill: "#D5D8DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4468 40.6604C75.2885 34.3625 72.3625 27.3787 70.1693 24.674C69.5606 23.8113 68.9152 22.3275 68.6686 21.6935C69.2705 21.2449 70.4249 20.5058 70.2283 21.1382C69.9826 21.9286 70.7784 22.4361 71.5795 23.2053C72.3806 23.9746 77.6257 24.3917 77.7799 31.9816C77.9033 38.0535 73.077 41.0666 70.6485 41.8142C69.0888 42.3695 69.1975 41.2764 69.4468 40.6604Z",
    fill: "#F1F2F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0449 24.3536C75.71 26.6559 81.2751 32.5126 73.3693 40.3186C75.4152 37.9206 78.8258 30.52 73.0449 24.3536Z",
    fill: "#D5D8DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-watermelon",
    d: "M71 25C71 26.8385 70.6379 28.659 69.9343 30.3576C69.2307 32.0561 68.1995 33.5995 66.8995 34.8995C65.5995 36.1995 64.0561 37.2307 62.3576 37.9343C60.659 38.6379 58.8385 39 57 39C55.1615 39 53.341 38.6379 51.6424 37.9343C49.9439 37.2307 48.4005 36.1995 47.1005 34.8995C45.8005 33.5995 44.7693 32.0561 44.0657 30.3576C43.3621 28.659 43 26.8385 43 25L57 25H71Z",
    fill: "#9DA4AF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1162 25C68.1162 26.46 67.8286 27.9057 67.2699 29.2545C66.7112 30.6034 65.8922 31.829 64.8599 32.8613C63.8275 33.8937 62.6019 34.7126 61.253 35.2713C59.9042 35.8301 58.4585 36.1176 56.9985 36.1176C55.5385 36.1176 54.0928 35.8301 52.744 35.2713C51.3951 34.7126 50.1695 33.8937 49.1371 32.8613C48.1048 31.829 47.2859 30.6034 46.7271 29.2545C46.1684 27.9057 45.8809 26.46 45.8809 25L56.9985 25H68.1162Z",
    fill: "#F1F2F4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1934 27.7824C50.2053 27.6751 50.2887 27.6247 50.3823 27.5935C50.4044 27.5861 50.6105 27.5441 50.5408 27.6138C50.4665 27.6881 50.3201 27.7807 50.2237 27.8128",
    stroke: "#67717E",
    strokeWidth: 1.23529,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.207 31.7906C56.32 31.6895 56.4518 31.6682 56.5714 31.6084",
    stroke: "#67717E",
    strokeWidth: 1.23529,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0039 27.7824C62.2034 27.737 62.3924 27.6452 62.5808 27.5698",
    stroke: "#67717E",
    strokeWidth: 1.23529,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4805 26.6289C56.5946 26.6025 56.7104 26.5291 56.8145 26.4771",
    stroke: "#67717E",
    strokeWidth: 1.23529,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-sack",
    d: "M23.4498 37.1909C22.6501 32.4006 27.3001 29.143 29.725 28.113C33.5397 25.543 38.701 25.7267 41.7808 28.2269C44.2446 30.227 46.513 34.593 47.3391 36.5259C48.0803 37.1651 49.9891 37.563 49.1821 40.2946C48.375 43.0262 44.1652 45.9569 37.2528 49.2036C30.3404 52.4503 27.1322 51.2816 26.4751 50.6681C25.818 50.0547 25.6416 48.5384 25.8953 47.0122C26.149 45.486 24.4494 43.1789 23.4498 37.1909Z",
    fill: "#67717E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-sack",
    d: "M21.0992 26.6759C21.8219 28.7424 24.5541 30.3561 25.8298 30.9047C26.4373 30.4324 27.0008 30.019 27.5226 29.657C32.868 25.9484 33.9189 27.2377 33.2014 26.3068C32.4138 25.285 32.6466 19.9739 31.6013 20.4851C30.5559 20.9963 32.2401 20.1727 29.1774 20.8262C26.1146 21.4798 24.4428 23.2118 22.8316 24.7735C21.2205 26.3352 20.1959 24.0928 21.0992 26.6759Z",
    fill: "#67717E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.2308,
    cy: 37.1569,
    r: 5.17204,
    transform: "rotate(-26.0591 34.2308 37.1569)",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-sack",
    d: "M34.2089 39.5266C33.9047 40.3494 32.5112 40.0974 31.541 38.4109C32.8155 38.1055 34.9232 37.9857 34.2089 39.5266Z",
    fill: "#67717E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-sack",
    d: "M34.6683 39.3912C35.0638 40.1743 36.3269 39.8129 37 38.0776C35.7718 37.8819 33.7931 37.9366 34.6683 39.3912Z",
    fill: "#67717E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-sack",
    d: "M34.0672 37.3315C33.9486 37.989 32.2894 37.9434 31.5625 36.1692C32.4708 36.1283 34.2681 36.2179 34.0672 37.3315Z",
    fill: "#67717E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-sack",
    d: "M34.5103 37.3262C34.771 37.9414 36.2643 37.5734 36.5098 35.7092C35.677 35.8468 34.0688 36.2844 34.5103 37.3262Z",
    fill: "#67717E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-sack",
    d: "M34.2841 36.2427C35.4685 36.0496 35.2807 34.8557 33.8008 33.613C33.4019 34.4951 32.5236 36.3023 34.2841 36.2427Z",
    fill: "#67717E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1863 27.7977C30.4454 26.8085 32.7638 26.2039 33.7657 26.0252C33.9294 26.36 33.9941 27.065 32.9425 27.2058C31.6281 27.3818 29.7445 28.3028 28.673 29.2936C27.6015 30.2844 25.8435 31.1441 25.0314 31.0744C24.2193 31.0047 24.8499 30.3851 25.8545 29.8938C26.8591 29.4025 27.6125 29.0341 29.1863 27.7977Z",
    fill: "#C4C4C4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3768 44.5877C34.188 43.9273 34.6839 43.2698 35.3707 43.2698H78.6293C79.3161 43.2698 79.812 43.9273 79.6232 44.5877L77.9975 50.2731C77.8706 50.7167 77.465 51.0226 77.0036 51.0226H36.9964C36.535 51.0226 36.1294 50.7167 36.0025 50.2731L34.3768 44.5877Z",
    fill: "#F1F2F4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3368 43.2696C44.3368 41.6247 43.9284 40.0471 43.2014 38.884C42.4745 37.7208 41.4885 37.0674 40.4604 37.0674C39.4323 37.0674 38.4463 37.7208 37.7194 38.884C36.9924 40.0471 36.584 41.6247 36.584 43.2696L40.4604 43.2696H44.3368Z",
    fill: "#67717E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38.659 39.6932C38.0433 40.7095 38.0189 41.821 37.6921 41.623C37.3653 41.425 37.5995 40.4406 38.2152 39.4244C38.8309 38.4081 39.595 37.7447 39.9218 37.9427C40.2486 38.1407 39.2747 38.677 38.659 39.6932Z",
    fill: "#D5D8DD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6063 43.2696C52.6063 41.6247 52.1979 40.0471 51.471 38.884C50.744 37.7208 49.758 37.0674 48.7299 37.0674C47.7018 37.0674 46.7159 37.7208 45.9889 38.884C45.2619 40.0471 44.8535 41.6247 44.8535 43.2696L48.7299 43.2696H52.6063Z",
    fill: "#67717E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9286 39.6932C46.3128 40.7095 46.2885 41.821 45.9616 41.623C45.6348 41.425 45.869 40.4406 46.4848 39.4244C47.1005 38.4081 47.8645 37.7447 48.1913 37.9427C48.5181 38.1407 47.5443 38.677 46.9286 39.6932Z",
    fill: "#D5D8DD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8778 43.2696C60.8778 41.6247 60.4694 40.0471 59.7424 38.884C59.0155 37.7208 58.0295 37.0674 57.0014 37.0674C55.9733 37.0674 54.9873 37.7208 54.2604 38.884C53.5334 40.0471 53.125 41.6247 53.125 43.2696L57.0014 43.2696H60.8778Z",
    fill: "#67717E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2 39.6932C54.5843 40.7095 54.5599 41.821 54.2331 41.623C53.9063 41.425 54.1405 40.4406 54.7562 39.4244C55.372 38.4081 56.136 37.7447 56.4628 37.9427C56.7896 38.1407 55.8158 38.677 55.2 39.6932Z",
    fill: "#D5D8DD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1473 43.2696C69.1473 41.6247 68.7389 40.0471 68.012 38.884C67.285 37.7208 66.299 37.0674 65.2709 37.0674C64.2428 37.0674 63.2569 37.7208 62.5299 38.884C61.8029 40.0471 61.3945 41.6247 61.3945 43.2696L65.2709 43.2696H69.1473Z",
    fill: "#67717E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4696 39.6932C62.8539 40.7095 62.8295 41.821 62.5027 41.623C62.1759 41.425 62.4101 40.4406 63.0258 39.4244C63.6415 38.4081 64.4056 37.7447 64.7324 37.9427C65.0592 38.1407 64.0853 38.677 63.4696 39.6932Z",
    fill: "#D5D8DD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4169 43.2696C77.4169 41.6247 77.0085 40.0471 76.2815 38.884C75.5545 37.7208 74.5686 37.0674 73.5405 37.0674C72.5124 37.0674 71.5264 37.7208 70.7994 38.884C70.0725 40.0471 69.6641 41.6247 69.6641 43.2696L73.5405 43.2696H77.4169Z",
    fill: "#67717E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7391 39.6932C71.1234 40.7095 71.099 41.821 70.7722 41.623C70.4454 41.425 70.6796 40.4406 71.2953 39.4244C71.911 38.4081 72.6751 37.7447 73.0019 37.9427C73.3287 38.1407 72.3548 38.677 71.7391 39.6932Z",
    fill: "#D5D8DD"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M79.6232 41.4348C79.812 42.0952 79.3161 42.7527 78.6293 42.7527L35.3707 42.7527C34.6839 42.7527 34.188 42.0952 34.3768 41.4348L36.0025 35.7494C36.1294 35.3057 36.535 34.9999 36.9964 34.9999L77.0036 34.9999C77.465 34.9999 77.8706 35.3057 77.9975 35.7494L79.6232 41.4348Z",
    fill: "#F1F2F4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-bottle",
    d: "M84.6183 33.4054C85.1096 32.7261 86.0586 32.5737 86.7379 33.0649C87.4172 33.5562 87.5697 34.5052 87.0784 35.1845L84.7951 38.3417C83.381 40.2971 83.7568 43.0571 83.5347 45.4601C83.4508 46.3672 83.1318 47.2615 82.5618 48.0497C81.6926 49.2516 80.4061 49.9767 79.0344 50.1741C78.6933 50.2232 78.3734 50.3874 78.1714 50.6666C77.8071 51.1704 77.1034 51.2834 76.5997 50.9191L72.9571 48.2848C72.4534 47.9205 72.3404 47.2168 72.7047 46.7131C72.9066 46.4338 72.9623 46.0786 72.9021 45.7393C72.66 44.3748 72.9457 42.9259 73.8149 41.724C74.3849 40.9359 75.1343 40.3528 75.9696 39.989C78.1821 39.0254 80.9209 38.518 82.3351 36.5626L84.6183 33.4054Z",
    fill: "#9DA4AF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5198 44.853C75.4621 45.0229 74.4206 44.2587 74.7786 43.249C74.817 43.1408 74.8603 43.034 74.9084 42.929C75.2281 42.2316 75.7474 41.6445 76.4007 41.2422C77.054 40.8399 77.8119 40.6403 78.5787 40.6688C79.3454 40.6972 80.0865 40.9524 80.7082 41.402C81.3299 41.8516 81.8043 42.4755 82.0714 43.1947C82.3386 43.914 82.3864 44.6963 82.2089 45.4427C82.0315 46.1892 81.6366 46.8662 81.0744 47.3883C80.9897 47.4668 80.9019 47.5414 80.8111 47.6117C79.9644 48.2679 78.9124 47.5182 78.7425 46.4605C78.5726 45.4028 77.5775 44.6831 76.5198 44.853Z",
    fill: "#F1F2F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.03596,
    height: 1.34932,
    transform: "matrix(-0.810305 -0.586008 -0.586008 0.810305 88.0664 33.8179)",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-bottle",
    d: "M89.0558 32.4512C89.547 31.7719 89.3946 30.8229 88.7153 30.3316C88.036 29.8404 87.087 29.9928 86.5957 30.6721L85.6073 32.0388L88.0674 33.8179L89.0558 32.4512Z",
    fill: "#9DA4AF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-cart",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9038 41.0326C17.5794 40.6939 17.0739 40.6024 16.6513 40.806L15.9311 41.153C15.321 41.447 15.1273 42.2226 15.5276 42.7689L23.8502 54.127C23.9614 54.2788 24.0311 54.4569 24.0526 54.6439L26.5594 76.5114C26.6221 77.0583 27.0916 77.4712 27.6421 77.4712C28.2403 77.4712 28.7326 77.9561 28.7326 78.5543V84.3309C28.7326 84.9291 29.2175 85.414 29.8157 85.414H30.5378C31.136 85.414 31.6209 84.9291 31.6209 84.3309V78.5543C31.6209 77.9561 32.1058 77.4712 32.704 77.4712H69.5301C70.1282 77.4712 70.6132 77.9561 70.6132 78.5543V84.3309C70.6132 84.9291 71.0981 85.414 71.6963 85.414H72.4184C73.0166 85.414 73.5015 84.9291 73.5015 84.3309V77.9322C73.5015 77.6776 73.7079 77.4712 73.9625 77.4712C74.1513 77.4712 74.321 77.356 74.3909 77.1806L85.3233 49.7106C85.6064 48.9994 85.0824 48.227 84.317 48.227H25.2558C24.9605 48.227 24.6779 48.1063 24.4736 47.893L17.9038 41.0326ZM26.7184 52.4017C26.6376 51.7553 27.1417 51.1844 27.7931 51.1844H79.5209C80.277 51.1844 80.8004 51.9394 80.5352 52.6475L79.0732 56.5498C78.9147 56.9727 78.5105 57.2529 78.0589 57.2529H28.2805C27.7342 57.2529 27.2734 56.8461 27.2057 56.304L26.7184 52.4017ZM27.8369 61.3586C27.7562 60.7122 28.2602 60.1413 28.9117 60.1413H76.1653C76.9214 60.1413 77.4448 60.8963 77.1795 61.6044L75.827 65.2148C75.6685 65.6377 75.2643 65.9179 74.8127 65.9179H29.3625C28.8163 65.9179 28.3555 65.5111 28.2878 64.969L27.8369 61.3586ZM30.0174 68.8062C29.3577 68.8062 28.8512 69.3909 28.9454 70.0438L29.428 73.3923C29.5048 73.9253 29.9615 74.3209 30.5 74.3209H71.3853C71.8173 74.3209 72.208 74.0642 72.3795 73.6677L73.8273 70.3192C74.1365 69.6041 73.6122 68.8062 72.8331 68.8062H30.0174Z",
    fill: "#818A98"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5381,
    cy: 85.414,
    r: 6.13767,
    fill: "#67717E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-background",
    cx: 30.5376,
    cy: 85.414,
    r: 4.33247,
    fill: "#B9BEC6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5368,
    cy: 85.4142,
    r: 2.88832,
    fill: "#67717E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.0576,
    cy: 85.414,
    r: 6.13767,
    fill: "#67717E"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-background",
    cx: 72.0571,
    cy: 85.414,
    r: 4.33247,
    fill: "#B9BEC6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.0563,
    cy: 85.4142,
    r: 2.88832,
    fill: "#67717E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-cart",
    x: 12,
    y: 43.387,
    width: 9.50562,
    height: 6.35463,
    rx: 2.64045,
    transform: "rotate(-34.5211 12 43.387)",
    fill: "#818A98"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroceryStoreThumbnailGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/GroceryStoreThumbnailGray.d87da48cd43ede649e51f61b46dcef9d.svg";